import Head from 'next/head';

import Footer from 'components/Footer';
import Header from 'components/Header';
import { HeroSearching } from 'components/SummitFlow/HeroSearching';

import { FC } from 'react';

const Searching: FC = () => {
  return (
    <div className="page-wrapper">
      <Head>
        <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
        <title>Find Home Service Pros Near You</title>
      </Head>
      <Header />
      <HeroSearching />
      <Footer />
    </div>
  );
};

export default Searching;
